import { Suspense, lazy } from 'react';
import type { CategoryChartProps } from './CategoryChart';

/**
 * CategoryChart behind the same code split as LazyTrendChart.
 *
 * Both wrappers exist for one reason: `import { CategoryChart } from './charts'`
 * — or from the component module directly — pulls Recharts into whatever chunk
 * the importer lives in, with no error and no failing test. Render charts
 * through these two modules and the split holds.
 */
const CategoryChart = lazy(() => import('./CategoryChart'));

export const LazyCategoryChart: React.FC<CategoryChartProps> = props => (
  <Suspense
    fallback={
      <div
        className="chart-loading"
        style={{ height: props.height ?? 260 }}
        role="status"
      >
        Memuat grafik...
      </div>
    }
  >
    <CategoryChart {...props} />
  </Suspense>
);

export default LazyCategoryChart;
